import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoHolidaysGetRes } from "./abst/DtoHolidaysGetRes";

export class DtoHolidaysGetResImple extends DtoHolidaysGetRes {
  public pager = new DtoApiPager();
}
